import { render, staticRenderFns } from "./ProductMasterData.vue?vue&type=template&id=871e9220"
import script from "./ProductMasterData.vue?vue&type=script&lang=js"
export * from "./ProductMasterData.vue?vue&type=script&lang=js"
import style0 from "./ProductMasterData.vue?vue&type=style&index=0&id=871e9220&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports